import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import ForgotPasswordView from '../views/ForgotPasswordView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import AppLayout from '../layouts/AppLayout.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { guestOnly: true }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPasswordView,
    meta: { guestOnly: true }
  },
  {
    path: '/reset-password',
    alias: '/api/v1/password/edit',
    name: 'reset-password',
    component: ResetPasswordView,
    meta: { guestOnly: true }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: { guestOnly: true }
  },
  {
    path: '/',
    component: AppLayout,
    meta: { requiresAuth: true }, // Protège l'accès à toute cette zone
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView
      },
      {
        path: 'projects',
        name: 'projects-list',
        component: () => import('../views/ProjectsView.vue')
      },
      {
        path: 'projects/:id',
        name: 'project-detail',
        component: () => import('../views/ProjectDetailView.vue')
      },
      {
        path: 'kanban',
        name: 'kanban',
        component: () => import('../views/KanbanView.vue')
      },
      {
        path: 'comptes',
        name: 'comptes',
        component: () => import('../views/ComptesView.vue')
      },
      {
        path: 'maintenance',
        name: 'maintenance',
        component: () => import('../views/MaintenanceView.vue')
      },
      {
        path: 'aide',
        name: 'aide',
        component: () => import('../views/AideView.vue')
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
      },
      {
        path: 'mentions-legales',
        name: 'mentions-legales',
        component: () => import('../views/MentionsLegalesView.vue')
      },
      {
        path: 'confidentialite',
        name: 'confidentialite',
        component: () => import('../views/ConfidentialiteView.vue')
      },
      {
        path: 'cgu',
        name: 'cgu',
        component: () => import('../views/CguView.vue')
      },
      {
        path: 'cgv',
        name: 'cgv',
        component: () => import('../views/CgvView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// VÉRIFICATION DE CONNEXION AVANT CHAQUE CHANGEMENT DE PAGE
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  // 1. Si la route demande une connexion et qu'on n'a pas de token -> redirection vers /login
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({ name: 'login' })
      return
    }
  }

  // 2. Si on est déjà connecté et qu'on tente d'aller sur une page d'invité -> redirection vers Accueil
  if (to.matched.some(record => record.meta.guestOnly)) {
    if (token) {
      next({ name: 'home' })
      return
    }
  }

  next()
})

export default router
